<template>
  <header class="header">
    <div class="table-actions-wrap">
      <div class="left-aligned-wrap">
        <woot-sidemenu-icon />
        <h1 class="page-title header-title">
          {{ headerTitle }}
        </h1>

        <div 
          class="menu"
          :class="{ 'active': activeTab === 'campaigns' }"
          @click="setActiveTab('campaigns')"
        >
          <p class="kanban-context--name text-ellipsis">
            {{ $t('CAMPAIGN_FLOW.TITLE') }}
          </p>
        </div>
        <div 
          class="menu"
          :class="{ 'active': activeTab === 'list' }"
          @click="setActiveTab('list')"
        >
          <p class="kanban-context--name text-ellipsis">
            {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.TITLE') }}
          </p>
        </div>
      </div>
    </div>
    <woot-button
      v-if="activeTab == 'list'" 
      color-scheme="success" 
      icon="add-circle"
      @click="toggleModalContacts"
    >
    {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.TITLE') }}
    </woot-button>
    <woot-button
      v-else 
      color-scheme="success" 
      icon="add-circle"
      @click="$emit('enable-card-new-campaign', true)"
    >
    {{ $t('CAMPAIGN_FLOW.CREATE.TITLE') }}
    </woot-button>

    <modal-create-list-contacts
      v-if="modalListContacts" 
      :show="modalListContacts"
      :onClose="toggleModalContacts"
      @submit="handleListContacts"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';
import ModalCreateListContacts from './ModalCreateListContacts.vue';

export default {
  mixins: [adminMixin],
  components: {ModalCreateListContacts},
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTab: 'campaigns',
      modalListContacts: false
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
    }),
  },
  mounted(){
    this.handleTab(this.activeTab);
    this.$store.dispatch('campaignsFlow/get')
  },
  methods: {
    async handleListContacts(payload){
      const newList = {
        campaign_contact_list: {
          ...payload,
          account_id: this.accountId
        }
      }
      await this.$store.dispatch('campaignsContactList/create', newList);
      this.toggleModalContacts();
    },
    toggleModalContacts(){
      this.modalListContacts = !this.modalListContacts;
    },
    setActiveTab(tab) {

      this.activeTab = tab;
      this.handleTab(tab);
    },
    handleTab(tab){
      this.$store.dispatch('campaignsContactList/setTab', { tab })
      this.$emit('handle-tab', tab);
    }
  },
}
</script>

<style lang="scss" scoped>

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
}
.menu {
  min-width: 80px;
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-mini);
  padding: 0.6rem;
  position: relative;
  cursor: pointer;

  &:hover {
    background: var(--b-100);
  }

  &.active {
    background-color: var(--color-highlight); /* Aplique a cor de destaque desejada */
    color: var(--g-20);
  }

  .kanban-context--name {
    font-weight: var(--font-weight-medium);
    margin-bottom: 0;
  }
}

.card-kanban {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(95% - 175px);
  padding-right: 175px;
}

.table-actions-wrap {
  display: flex;
  gap: 3rem;
  min-height: 55px;
  padding: var(--space-small) var(--space-normal) var(--space-small) var(--space-normal);
}

.custom-select {
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  font-size: var(--font-size-medium);
  margin: 0;
}

.box-select-kanban {
  display: flex;
  align-items: center;
  gap: 10px;
}

.box-select-kanban label {
  white-space: nowrap;
  font-size: 1.6rem;
  font-weight: bold;
}

.page-title {
  margin: 0;
}

.left-aligned-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  max-width: 100%;
  min-width: var(--space-mega);

  .header-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
